import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["latField", "lngField", "ratingField", "priceField", "typeField", "verifiedOnlyField", "queryField", "hmvField"]

  connect() {
    // Optionally remove highlight after a short time
    // Clear any existing timeout to ensure idempotency
    clearTimeout(this._removeHighlightTimeout);
    this._removeHighlightTimeout = null;
  }
  // Handler for the test button: focus and highlight the city search box
  focusSearchBox(event) {
    event.preventDefault();
    if (this.hasQueryFieldTarget) {
      const cityInput = this.queryFieldTarget;
      cityInput.focus();
      cityInput.select();
      cityInput.classList.add('transition', 'duration-150', 'ease-in-out', 'ring', 'ring-2', 'scale-[1.02]');
      clearTimeout(this._removeHighlightTimeout);
      this._removeHighlightTimeout = setTimeout(() => {
        cityInput.classList.remove('transition', 'duration-150', 'ease-in-out', 'ring', 'ring-2', 'scale-[1.02]');
      }, 500);
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      this.submitSearch(event)
    }
  }

  submitSearch(event) {
    if (event) {
      event.preventDefault()
    }
    
    let form = this.getForm()
    
    if (form) {
      setTimeout(() => {
        form.submit()
      }, 10)
    }
  }
  
  getForm() {
    let form = this.element.closest('form')
    
    if (form) {
      return form
    }
    
    form = this.element.querySelector('form')
    if (form) {
      return form
    }
    
    const allForms = document.querySelectorAll('form')
    for (let i = 0; i < allForms.length; i++) {
      if (allForms[i].contains(this.element)) {
        return allForms[i]
      }
    }
    
    const searchContainer = document.querySelector('[data-controller="provider-search"]')
    if (searchContainer) {
      form = searchContainer.querySelector('form')
      if (form) {
        return form
      }
    }
    
    return null
  }

  setRating(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const ratingValue = event.currentTarget.dataset.ratingValue
    
    if (this.hasRatingFieldTarget) {
      this.ratingFieldTarget.value = ratingValue
      
      setTimeout(() => {
        this.submitSearch()
      }, 50)
    }
  }

  setPrice(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const priceValue = event.currentTarget.dataset.priceValue
    
    if (this.hasPriceFieldTarget) {
      this.priceFieldTarget.value = priceValue
      
      setTimeout(() => {
        this.submitSearch()
      }, 50)
    }
  }

  setType(event) {
    event.preventDefault();
    event.stopPropagation();

    const typeValue = event.currentTarget.dataset.typeValue;

    // reset type specific filters
    if (this.hasHmvFieldTarget) {
      this.hmvFieldTarget.value = ""; 
    }
    if(this.hasVerifiedOnlyFieldTarget) {
      this.verifiedOnlyFieldTarget.value = "0";
    }

    if (this.hasTypeFieldTarget) {
      this.typeFieldTarget.value = typeValue;

      setTimeout(() => {
        this.submitSearch();
      }, 50);
    }
  }

  setHmvCategory(event) {
    event.preventDefault()
    event.stopPropagation()
    
    // This matches the data-hmv-value we put on the button in the HTML
    const hmvValue = event.currentTarget.dataset.hmvValue
    
    if (this.hasHmvFieldTarget) {
      this.hmvFieldTarget.value = hmvValue
      
      setTimeout(() => {
        this.submitSearch()
      }, 50)
    }
  }

  clearHmvCategory(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (this.hasHmvFieldTarget) {
      this.hmvFieldTarget.value = ""
      
      setTimeout(() => {
        this.submitSearch()
      }, 50)
    }
  }

  setVerifiedOnly(event) {
    const isChecked = event.currentTarget.checked;

    if (this.hasVerifiedOnlyFieldTarget) {
      this.verifiedOnlyFieldTarget.value = isChecked ? "1" : "0";

      setTimeout(() => {
        this.submitSearch();
      }, 50);
    }
  }
}
